/**
 *
 * HeaderLayout
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link, useHistory, useLocation } from 'react-router-dom';

// styles
import './style.scss';

// antd component
import { Button, Layout, Space, Tooltip } from 'antd';
// import { Drawer, Icon, List, NavBar, TabBar } from 'antd-mobile';
const { Header } = Layout;

// assets
import CustomIcons from 'components/CustomIcons';

// components
import UserAvatar from 'components/UserAvatar';

// context
import { useLogout, useGetLocalUser } from 'engine/Contexts/User.context';
// helper
import { SCHOOL_INFORMATION } from 'utils/helpers/helper.constant';

function HeaderLayout({
  notifications,
  // actions
  notificationsAction,
  // default props
  className,
  ...rest
}) {
  const localUser = useGetLocalUser()();
  const childClassNames = classNames('layout-header', localUser?.role, className);
  const logOut = useLogout();

  return (
    <Header className={childClassNames} {...rest}>
      <Link className="header-logo" to="/home">
        {localUser?.role == 'teacher' ? (
          <CustomIcons className="header-logo__image" type="logo-white" />
        ) : (
          <CustomIcons className="header-logo__image" type="logo" />
        )}
        <span className="header-logo__description">
          {SCHOOL_INFORMATION?.name}
        </span>
      </Link>
      <Space
        size={'middle'}
        style={{ justifyContent: 'flex-end', width: '100%' }}
      >
        {/*   <div
          className="header-notifications"
          onClick={notificationsAction}
        >
          <Tooltip placement="bottom" title="Mes notifications">
            <Badge
              overflowCount={10}
              className="header-notifications__counter"
              count={
                notifications && notifications.length
              }
            >
              <Link to="/notifications">
                <CustomIcons type="notifications-in-app" />
              </Link>
            </Badge>
          </Tooltip>
        </div> */}
        <Tooltip placement="bottom" title="Se déconnecter">
          <Button
            type={'text'}
            className="logout-bar"
            onClick={logOut}
            style={{ marginLeft: '15px' }}
          >
            <CustomIcons type={'logout'} />
          </Button>
        </Tooltip>
      </Space>
    </Header>
  );
}

HeaderLayout.propTypes = {
  notificationsAction: PropTypes.func.isRequired,
};

export default memo(HeaderLayout);
